import { XMarkIcon } from "@heroicons/react/24/outline";
import Dialog from ".";
import { IconLoading } from "../../assets/icons";

const DialogAsk = ({ open, onClose, title, onConfirm, loading, children, width = "450px", confirmDisabled }) => {
  return (
    <Dialog
      open={open}
      onClose={() => {
        if (loading) return;
        onClose();
      }}
      width={width}
      className="!bg-[#FFFFFF] !ring-1 !ring-[#D9D9D9]"
    >
      <div>
        {/* <div className="flex items-center justify-end w-full pb-1">
          <button
            className="bg-transparent hover:bg-transparent text-black"
            onClick={onClose}
          >
            <XMarkIcon className="w-[18px] h-[18px]" />
          </button>
        </div> */}

        <div className="mt-3 flex flex-col items-center">
          <svg
            viewBox="0 0 95 95"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="w-[100px] h-[100px]"
          >
            <rect
              x="7"
              y="7"
              width="80.75"
              height="80.75"
              rx="40.375"
              stroke="#FFF4E0"
              strokeWidth="13.4583"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.25 47C13.25 28.1525 28.5275 12.875 47.375 12.875C66.2225 12.875 81.5 28.1525 81.5 47C81.5 65.8475 66.2225 81.125 47.375 81.125C28.5275 81.125 13.25 65.8475 13.25 47ZM53.073 33.2905C49.958 30.571 44.792 30.571 41.6805 33.2905C41.1565 33.7491 40.4718 33.9807 39.777 33.9344C39.0822 33.8881 38.4343 33.5678 37.9757 33.0437C37.5172 32.5197 37.2856 31.835 37.3318 31.1403C37.3781 30.4455 37.6985 29.7976 38.2225 29.339C43.3115 24.887 51.4385 24.887 56.5275 29.339C61.823 33.973 61.823 41.652 56.5275 46.286C55.6419 47.0582 54.6566 47.708 53.598 48.218C51.232 49.366 50 50.927 50 52.25V54.875C50 55.5712 49.7234 56.2389 49.2312 56.7312C48.7389 57.2234 48.0712 57.5 47.375 57.5C46.6788 57.5 46.0111 57.2234 45.5188 56.7312C45.0266 56.2389 44.75 55.5712 44.75 54.875V52.25C44.75 47.7735 48.46 44.8755 51.3125 43.493C51.9495 43.185 52.541 42.7965 53.073 42.3345C55.978 39.79 55.978 35.835 53.073 33.2905ZM47.375 68C48.0712 68 48.7389 67.7234 49.2312 67.2312C49.7234 66.7389 50 66.0712 50 65.375C50 64.6788 49.7234 64.0111 49.2312 63.5188C48.7389 63.0266 48.0712 62.75 47.375 62.75C46.6788 62.75 46.0111 63.0266 45.5188 63.5188C45.0266 64.0111 44.75 64.6788 44.75 65.375C44.75 66.0712 45.0266 66.7389 45.5188 67.2312C46.0111 67.7234 46.6788 68 47.375 68Z"
              fill="#FFC641"
            />
          </svg>
          <span className="font-semibold text-center block mt-6 text-xl">
            {title}
          </span>
        </div>

        {children && <div className="mt-4">{children}</div>}

        <div className="mt-6 flex gap-4">
          <button
            type="submit"
            className="w-full relative overflow-hidden !py-3 !font-bold !text-lg !bg-[#007A78] disabled:!opacity-40 disabled:cursor-not-allowed"
            onClick={onConfirm}
            disabled={loading || confirmDisabled}
          >
            {loading ? (
              <div className="animate-spin w-fit flex justify-center items-center mx-auto">
                <IconLoading className="w-[24px] h-[24px]" />
              </div>
            ) : (
              "Yes"
            )}
          </button>
          <button
            type="submit"
            className="w-full relative overflow-hidden !py-3 !font-bold !text-lg !bg-[transparent]  ring-1 ring-[#007A78] text-[#007A78]"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default DialogAsk;
